import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const faqs = [{
  q: 'What exactly do I get with my purchase?',
  a: 'You get instant access to 100+ step-by-step robot project guides in PDF format, plus all 3 bonuses: the Cardboard Arcade Pack, The 5-Minute Papercraft Guide, and Little Creators: Slimes & Sensory Play. Everything is delivered digitally — no shipping and no waiting.',
  tone: 'bg-sky-light'
}, {
  q: 'What materials do I need to buy?',
  a: 'You already have almost everything you need at home — cardboard boxes, plastic bottles, tape, rubber bands, bottle caps, pens, and scissors. Every project clearly lists the required materials in advance, so there are no surprises.',
  tone: 'bg-sunshine-light'
}, {
  q: 'What ages is MakerLab for?',
  a: 'MakerLab is made for children ages 4 to 12. Projects are organized by difficulty: easy ones are perfect for younger kids with a little parental help, while the more advanced projects are ideal for older children who want a real engineering challenge.',
  tone: 'bg-brand-light'
}, {
  q: 'Does my child need any prior experience?',
  a: 'Not at all. Every project starts from zero — fully illustrated, step by step, and written in simple language every child can follow. No robotics knowledge, coding, or technical background needed. Just curiosity and two hands.',
  tone: 'bg-mint-light'
}, {
  q: 'How do I access my purchase?',
  a: 'Right after purchase, you will receive an email with a download link. You can access your files from any device — phone, tablet, or computer. The PDFs can be opened, saved, and printed as often as you like.',
  tone: 'bg-coral-light'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-41" data-mp="3nztjujnce255">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-42" data-mp="3o1eee99npl30">
        <SectionHeading eyebrow="Questions?" title={<>Frequently asked questions</>} subtitle="Everything you need to know before getting started." data-id="element-43" data-mp="1uhw7utn6oem0" />
        <div className="mt-12 space-y-3" data-id="element-44" data-mp="1kq9t4nbmzxei">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className={`overflow-hidden rounded-2xl border border-ink/10 ${f.tone}`} data-id="element-45" data-mp="1ftrnll8hfv14" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left" data-id="element-46" data-mp="28g4572o4thxp">
                  <span className="font-display text-base font-bold text-ink sm:text-lg" data-id="element-47" data-mp="s2dw1hi5o3h7">
                    {f.q}
                  </span>
                  <PlusIcon className={`h-5 w-5 flex-none text-brand transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-48" data-mp="nzpkv35yykh2" />
                </button>
                <AnimatePresence initial={false} data-id="element-49" data-mp="33nmtrezcj64x">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-50" data-mp="38n98xtyqiwgd">
                      <p className="px-6 pb-6 text-sm leading-relaxed text-ink/60" data-id="element-51" data-mp="1x2kh0ngfttmm">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}